(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alp-abandoned-checkout-popup"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {
    let cookie = document.cookie;
    if (cookie.includes('alp_abandoned_checkout_triggered=true')) {
      popupOpen();
      document.cookie = 'alp_abandoned_checkout_triggered=false; path=/; max-age=0';
    }

    let triggerButtons = document.querySelectorAll(`[type="submit"]#checkout, .alp-payment-button-wrapper`);
    triggerButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        document.cookie = 'alp_abandoned_checkout_triggered=true; path=/; max-age=86400';
      });
    });

    function globoPopupButtonControl(globoElement) {
      let interval = setInterval(() => {
        let button = globoElement.querySelector('.gfb__footer.wizard__footer button[data-next-text]');
        let buttonText = button.textContent;
        if (buttonText.includes('Submit')) {
          globoElement.classList.add('is-last-step');
        } else {
          globoElement.classList.remove('is-last-step');
        }
      }, 400);

      let closeButton = globoElement.querySelectorAll('.header.dismiss , .overlay');
      closeButton.forEach(function (button) {
        button.addEventListener('click', function () {
          clearInterval(interval);
          if (globoElement.classList.contains('is-last-step')) {
            globoElement.querySelector('.gfb__footer.wizard__footer button[data-next-text]').click();
          }
        });
      });
    }

    function popupOpen() {
      let popupId = document.querySelector('.alp-abandoned-checkout-popup[data-id]').getAttribute('data-id');
      let delay = document.querySelector('.alp-abandoned-checkout-popup[data-delay]').getAttribute('data-delay');
      delay = parseInt(delay);
      if (popupId) {
        setTimeout(function () {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', popupId]);
          console.log('Abandoned checkout popup opened');
        }, delay);
      }
      //
      let globoElement = document.querySelector('.globo-formbuilder-popup');
      if (globoElement) {
        globoElement.querySelector('.globo-form .floating-button').click();
        // globoPopupButtonControl(globoElement);
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-dropdown-sub-mega-menu-new-n1"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    $('.sub-mega-menu-new-flex').each(function () {
      const categoryListSwitcher = $(this).find('.category-list-switcher [data-title]');
      const categoryItemListWrapper = $(this).find('.category-item-list-wrapper[data-title]');
      categoryItemListWrapper.eq(0).addClass('active');
      categoryListSwitcher.eq(0).addClass('active');
      //
      categoryListSwitcher.on('click', function (e) {
        e.preventDefault();
        let $this = $(this);
        const title = $this.data('title');
        $this.addClass('active').siblings().removeClass('active');
        categoryItemListWrapper.each(function () {
          if ($(this).data('title') === title) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-dropdown-sub-menu-new"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    $('.sub-mega-menu-new-flex').each(function () {
      const categoryListSwitcher = $(this).find('.category-list-switcher [data-title]');
      const categoryItemListWrapper = $(this).find('.category-item-list-wrapper[data-title]');
      categoryItemListWrapper.eq(0).addClass('active');
      categoryListSwitcher.eq(0).addClass('active');
      //
      categoryListSwitcher.on('click', function (e) {
        e.preventDefault();
        let $this = $(this);
        const title = $this.data('title');
        $this.addClass('active').siblings().removeClass('active');
        categoryItemListWrapper.each(function () {
          if ($(this).data('title') === title) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-locale-link-prefix"] && !Shopify.designMode) return;
  try {
    (function () {
    const configEl = document.getElementById('alp-locale-link-prefix-config');
    if (!configEl) return;

    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      return;
    }

    const shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    const prefix = String(shopifyRoot || config.root || '').replace(/\/+$/, '');
    if (!prefix) return;

    const locale = String(config.locale || '').toLowerCase();
    const otherPrefixes = (config.roots || [])
      .map(function (root) {
        return String(root || '').replace(/\/+$/, '');
      })
      .filter(function (root) {
        return root && root !== prefix;
      });

    const skipProtocol = /^(mailto:|tel:|sms:|javascript:)/i;
    const fileExtension = /\.(pdf|zip|jpe?g|png|gif|webp|avif|svg|mp4|webm|css|js|json|xml|ico|woff2?)($|[?#])/i;

    function hasLocalePrefix(path) {
      if (path === prefix || path.indexOf(prefix + '/') === 0) return true;
      for (let i = 0; i < otherPrefixes.length; i++) {
        const other = otherPrefixes[i];
        if (path === other || path.indexOf(other + '/') === 0) return true;
      }
      return false;
    }

    function rewrite(anchor) {
      if (!anchor || anchor.tagName !== 'A') return;

      const hreflang = anchor.getAttribute('hreflang');
      if (hreflang && hreflang.toLowerCase() !== locale) return;

      const href = anchor.getAttribute('href');
      if (!href || anchor.hasAttribute('download')) return;

      const trimmed = href.trim();
      if (!trimmed || trimmed.charAt(0) === '#' || skipProtocol.test(trimmed) || fileExtension.test(trimmed)) return;

      let url;
      try {
        url = new URL(trimmed, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin) return;

      const path = url.pathname || '/';
      if (hasLocalePrefix(path)) return;

      url.pathname = path === '/' ? prefix : prefix + (path.charAt(0) === '/' ? path : '/' + path);

      const nextPath = url.pathname + url.search + url.hash;
      let rewritten = nextPath;
      if (trimmed.indexOf('//') === 0) {
        rewritten = '//' + url.host + nextPath;
      } else if (/^https?:\/\//i.test(trimmed)) {
        rewritten = url.origin + nextPath;
      }

      if (rewritten !== href) anchor.setAttribute('href', rewritten);
    }

    function scan(root) {
      if (!root) return;
      if (root.tagName === 'A') rewrite(root);
      if (!root.querySelectorAll) return;
      const links = root.querySelectorAll('a[href]');
      for (let i = 0; i < links.length; i++) rewrite(links[i]);
    }

    function start() {
      scan(document);
      const observer = new MutationObserver(function (mutations) {
        for (let i = 0; i < mutations.length; i++) {
          const mutation = mutations[i];
          if (mutation.type === 'attributes') {
            rewrite(mutation.target);
            continue;
          }
          const nodes = mutation.addedNodes;
          for (let j = 0; j < nodes.length; j++) {
            if (nodes[j].nodeType === 1) scan(nodes[j]);
          }
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['href'],
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-product-promotion-new-2-item-2"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    function setHeightLimit() {
      let el = $('.alp-combo-sale-select-additional-products-item');
      el.each(function () {
        let $this = $(this);
        let $show_more = $this.find('.promotion-new-item-2-show-more');
        if ($show_more.length > 0) {
          $this.addClass('has-show-more');
          let $maxHeight =
            $this.find('.promotion-new-item-list-a-i-flex').eq(0).outerHeight() +
            $this.find('.alp-product-promotion-new-2-i-title-2').outerHeight() +
            50;
          $this.css('--max-height', $maxHeight);
        } else {
          $this.parents('.alp-combo-sale-select-additional-products').css('--initial-max-height', $this.outerHeight());
        }
      });
    }
    setInterval(() => {
      setHeightLimit();
    }, 1000);
    $('.promotion-new-item-2-show-more').on('click', function () {
      let $this = $(this);
      $this.parents('.alp-combo-sale-select-additional-products-item').toggleClass('open');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-share-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const shareButtons = document.querySelectorAll('.alp-share-button');
    shareButtons.forEach((shareButton) => {
      shareButton.addEventListener('click', () => {
        const shareLink = shareButton.dataset.shareLink;
        const title = shareButton.dataset.title;
        const description = shareButton.dataset.description;
        navigator.share({
          title: title,
          text: description,
          url: shareLink,
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-shipping-table"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    class AlpShippingTableModal extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-alp-shipping-table-trigger]');
        this.overlay = this.querySelector('[data-alp-shipping-table-overlay]');
        this.closeButton = this.querySelector('[data-alp-shipping-table-close]');

        if (!this.trigger || !this.overlay || !this.closeButton) return;
        if (this.__bound) return;
        this.__bound = true;
        this.overlay.hidden = true;

        this.handleOpen = this.open.bind(this);
        this.handleClose = this.close.bind(this);
        this.handleOverlayClick = this.onOverlayClick.bind(this);
        this.handleKeydown = this.onKeydown.bind(this);

        this.trigger.addEventListener('click', this.handleOpen);
        this.closeButton.addEventListener('click', this.handleClose);
        this.overlay.addEventListener('click', this.handleOverlayClick);
        document.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        if (!this.__bound) return;
        this.trigger.removeEventListener('click', this.handleOpen);
        this.closeButton.removeEventListener('click', this.handleClose);
        this.overlay.removeEventListener('click', this.handleOverlayClick);
        document.removeEventListener('keydown', this.handleKeydown);
        this.__bound = false;
      }

      isOpen() {
        return this.overlay && !this.overlay.hidden;
      }

      open() {
        if (!this.overlay) return;
        this.overlay.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }

      close() {
        if (!this.overlay) return;
        this.overlay.hidden = true;
        document.documentElement.style.overflow = '';
      }

      onOverlayClick(event) {
        if (event.target === this.overlay) {
          this.close();
        }
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;
        if (this.isOpen()) {
          this.close();
        }
      }
    }

    if (!customElements.get('alp-shipping-table-modal')) {
      customElements.define('alp-shipping-table-modal', AlpShippingTableModal);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axx-discount-code-field-ver1"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#axx-discount-form');
    const input = form.querySelector('.axx-discount-code');
    const messageEl = form.querySelector('.axx-discount-message');
    const appliedContainer = form.querySelector('.axx-applied-discounts');
    const summaryContainer = document.querySelector('.axx-ajax-cart-discount-summary');

    if (!form || !input || !messageEl || !appliedContainer) return;

    // --- Helpers -------------------------------------------------------------

    // Fetch the current cart JSON
    function fetchCart() {
      return fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: {
          Accept: 'application/json',
        },
      }).then((res) => res.json());
    }

    // Extract discount codes from the cart JSON
    //
    // Depending on theme/Shopify version, discount codes may show as:
    // - cart.cart_level_discount_applications (type: 'discount_code')
    // - or sometimes cart.discount_code / cart.discount_codes (older)
    //
    // We normalize to an array of { code, title }.
    function getDiscountCodesFromCart(cart) {
      const codes = [];

      // Newer style: cart_level_discount_applications
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((app) => {
          // Only include discount-code-based apps, skip automatic discounts
          if (app.type === 'discount_code' && app.code) {
            codes.push({
              code: app.code,
              title: app.title || app.code,
            });
          }
        });
      }

      // Older style: cart.discount_code (single) or cart.discount_codes (array)
      if (!codes.length && cart.discount_code) {
        codes.push({ code: cart.discount_code, title: cart.discount_code });
      }

      if (!codes.length && Array.isArray(cart.discount_codes)) {
        cart.discount_codes.forEach((dc) => {
          if (dc.code) {
            codes.push({ code: dc.code, title: dc.code });
          }
        });
      }

      return codes;
    }

    // Build the `discount` string for /cart/update.js from a list of codes
    // e.g. ['SAVE10','SHIPFREE'] -> 'SAVE10,SHIPFREE'
    function formatDiscountString(codes) {
      return codes.join(',');
    }

    // Render applied discount codes under the input
    function renderAppliedDiscounts(codes) {
      if (!codes.length) {
        appliedContainer.innerHTML = '';
        return;
      }

      const list = document.createElement('ul');
      list.className = 'applied-discount-list';

      codes.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'applied-discount-item';

        const codeSpan = document.createElement('span');
        codeSpan.className = 'applied-discount-code';
        codeSpan.textContent = item.code;

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'applied-discount-remove';
        removeBtn.setAttribute('aria-label', `Remove discount code ${item.code}`);
        removeBtn.textContent = '×'; // Remove icon

        removeBtn.addEventListener('click', () => {
          removeDiscountCode(item.code);
        });

        li.appendChild(codeSpan);
        li.appendChild(removeBtn);
        list.appendChild(li);
      });

      appliedContainer.innerHTML = '';
      appliedContainer.appendChild(list);
    }

    // Apply ALL discount codes to the cart via /cart/update.js
    function updateCartDiscounts(codes) {
      const discountString = codes.length ? formatDiscountString(codes) : '';

      return fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          discount: discountString,
        }),
      }).then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw data;
          });
        }
        return response.json();
      });
    }

    function showMessage(message) {
      messageEl.textContent = message;
      messageEl.classList.remove('hidden');
      setTimeout(() => {
        messageEl.classList.add('hidden');
      }, 4000);
    }

    // Remove a single code from the list and update the cart
    function removeDiscountCode(codeToRemove, message) {
      form.classList.add('loading');
      fetchCart()
        .then((cart) => {
          const codes = getDiscountCodesFromCart(cart).map((c) => c.code);
          const remaining = codes.filter((c) => c !== codeToRemove);

          return updateCartDiscounts(remaining);
        })
        .then((updatedCart) => {
          showMessage(message || `${codeToRemove} removed.`);

          const currentCodes = getDiscountCodesFromCart(updatedCart).map((c) => c.code);
          renderAppliedDiscounts(getDiscountCodesFromCart(updatedCart));

          // Optionally: refresh totals / cart UI from updatedCart
          console.log('Updated cart after removing code:', updatedCart);

          // update discount summary
          const grouped = getGroupedDiscountsFromCart(updatedCart);
          renderDiscountSummary(summaryContainer, grouped);

          // refresh cart
          AlpFn.refreshCart('[data-ajax-cart]');

          form.classList.remove('loading');
        })
        .catch((error) => {
          console.error('Error removing discount:', error);
          showMessage('Unable to remove discount. Please try again.');
          form.classList.remove('loading');
          input.value = '';
        });
    }

    // --- Init: fetch cart and render applied codes --------------------------

    async function init() {
      fetchCart()
        .then((cart) => {
          // const codes = getDiscountCodesFromCart(cart);
          // renderAppliedDiscounts(codes);
          form.classList.add('loading');
          let AllCodes = cart.discount_codes;
          let appliedCodes = [];
          AllCodes.forEach((code) => {
            if (code.applicable) {
              appliedCodes.push(code.code);
            }
          });
          appliedCodesToStr = appliedCodes.join(',');
          let updates = {
            discount: appliedCodesToStr,
          };
          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updates),
          })
            .then((response) => response.json())
            .then((data) => {
              // console.log(data);
              const codes = getDiscountCodesFromCart(data);
              renderAppliedDiscounts(codes);
              console.log('Applied discount codes:', codes);

              // update discount summary
              const grouped = getGroupedDiscountsFromCart(data);
              renderDiscountSummary(summaryContainer, grouped);

              form.classList.remove('loading');
            });
        })
        .catch((err) => {
          console.error('Error fetching cart:', err);
          form.classList.remove('loading');
        });
    }

    window.addEventListener('refreshAjaxCart', init);

    // add newCode
    function addNewCode(newCode) {
      form.classList.add('loading');
      // Strategy:
      // 1. Fetch current cart & existing codes
      // 2. Add new code to the list (if not already present)
      // 3. POST all codes as a single string to cart/update.js
      fetchCart()
        .then((cart) => {
          const existingCodes = getDiscountCodesFromCart(cart).map((c) => c.code.toLowerCase());

          const mergedCodes = [...new Set([...existingCodes, newCode.toLowerCase()])];

          return updateCartDiscounts(mergedCodes);
        })
        .then((updatedCart) => {
          // check if the discount is applicable, if not, show the error message and remove this discount code
          let thisCode = updatedCart.discount_codes.find((code) => code.code.toLowerCase() === newCode.toLowerCase());
          if (!thisCode.applicable) {
            console.log('Discount is not applicable:', thisCode);
            removeDiscountCode(thisCode.code.toLowerCase(), `${thisCode.code} is not applicable.`);
            input.value = '';
            return;
          }

          // showMessage('Discount applied.');

          input.value = '';

          const codes = getDiscountCodesFromCart(updatedCart);
          renderAppliedDiscounts(codes);

          // update discount summary
          const grouped = getGroupedDiscountsFromCart(updatedCart);
          renderDiscountSummary(summaryContainer, grouped);

          // Optionally: re-render cart totals, etc.
          console.log('Updated cart with discount(s):', codes);

          // refresh line item discount summary and cart

          AlpFn.refreshCart('[data-ajax-cart]');

          form.classList.remove('loading');
        })
        .catch((error) => {
          console.error('Error applying discount:', error);
          showMessage('Unable to apply this discount.');
          form.classList.remove('loading');
          input.value = '';
        });
    }

    // --- Form submit: apply a discount code ---------------------------------

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const newCode = input.value.trim();
      if (!newCode) {
        // showMessage('Please enter a discount code.');
        return;
      }

      addNewCode(newCode);
    });

    // discount-summary -----------------------------------

    // Build a friendly label from a discount_application / cart_level_discount_application
    function getDiscountLabel(app) {
      // Prefer a human-readable title; fallback to code; fallback to type
      return app.title || app.code || app.type || 'Discount';
    }

    // Returns array of { label, totalAmount } where totalAmount is a number (in shop currency)
    function getGroupedDiscountsFromCart(cart) {
      const groups = Object.create(null); // { [label]: totalAmountNumber }

      // 1) Line-item level discounts
      if (Array.isArray(cart.items)) {
        cart.items.forEach((item) => {
          if (!Array.isArray(item.line_level_discount_allocations)) return;

          item.line_level_discount_allocations.forEach((alloc) => {
            const app = alloc.discount_application || {};
            const label = getDiscountLabel(app);
            const amount = parseFloat(alloc.amount || '0') || 0;

            if (!groups[label]) {
              groups[label] = 0;
            }
            groups[label] += amount;
          });
        });
      }

      // 2) Cart-level discount applications
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((app) => {
          let thisApp = app.discount_application || app;
          // console.log('cart_level_discount_applications:', thisApp);
          if (thisApp.type === 'discount_code') {
            const label = getDiscountLabel(thisApp);
            const amount = parseFloat(thisApp.total_allocated_amount || '0') || 0;

            if (!groups[label]) {
              groups[label] = 0;
            }
            groups[label] += amount;
          }
        });
      }

      // Convert map → array
      return Object.keys(groups).map((label) => ({
        label,
        totalAmount: groups[label],
      }));
    }

    function formatMoneyFromNumber(amount) {
      // amount is a number in store currency (e.g. 5 -> $5.00)
      // Use Shopify's money formatting if needed; this simple example uses Intl
      // Adjust currency code and locale to your store.
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.shopCurrentCurrency,
      }).format(amount);
    }

    function renderDiscountSummary(container, discounts) {
      if (!container) return;

      if (!discounts.length) {
        container.innerHTML = '';
        return;
      }

      const list = document.createElement('ul');
      list.className = 'discount-summary-list';

      discounts.forEach((d) => {
        const li = document.createElement('li');
        li.className = 'discount-summary-item';

        const nameSpan = document.createElement('span');
        nameSpan.className = 'discount-summary-name';
        nameSpan.innerHTML = `${window.shopDiscountLabelSvgHtml} ${d.label}`;

        const amountSpan = document.createElement('span');
        amountSpan.className = 'discount-summary-amount';
        // Show as negative amount
        amountSpan.textContent = '-' + formatMoneyFromNumber(d.totalAmount / 100.0);

        li.appendChild(nameSpan);
        li.appendChild(amountSpan);
        list.appendChild(li);
      });

      container.innerHTML = '';
      container.appendChild(list);
    }

    window.refreshAjaxCartDiscountSummary = () => {
      fetchCart()
        .then((cart) => {
          const grouped = getGroupedDiscountsFromCart(cart);
          renderDiscountSummary(summaryContainer, grouped);
        })
        .catch((err) => {
          console.error('Error fetching cart for discounts:', err);
        });
    };

    init();
    // window.refreshAjaxCartDiscountSummary();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axx-discount-code-field"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#axx-discount-form');
    const input = form.querySelector('.axx-discount-code');
    const messageEl = form.querySelector('.axx-discount-message');
    const appliedContainer = form.querySelector('.axx-applied-discounts');
    const summaryContainer = document.querySelector('.axx-ajax-cart-discount-summary');

    if (!form || !input || !messageEl || !appliedContainer) return;

    // --- Helpers -------------------------------------------------------------

    // Fetch the current cart JSON
    function fetchCart() {
      return fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: {
          Accept: 'application/json',
        },
      }).then((res) => res.json());
    }

    // Extract discount codes from the cart JSON
    //
    // Depending on theme/Shopify version, discount codes may show as:
    // - cart.cart_level_discount_applications (type: 'discount_code')
    // - or sometimes cart.discount_code / cart.discount_codes (older)
    //
    // We normalize to an array of { code, title }.
    function getDiscountCodesFromCart(cart) {
      const codes = [];

      // Newer style: cart_level_discount_applications
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((app) => {
          // Only include discount-code-based apps, skip automatic discounts
          if (app.type === 'discount_code' && app.code) {
            codes.push({
              code: app.code,
              title: app.title || app.code,
            });
          }
        });
      }

      // Older style: cart.discount_code (single) or cart.discount_codes (array)
      if (!codes.length && cart.discount_code) {
        codes.push({ code: cart.discount_code, title: cart.discount_code });
      }

      if (!codes.length && Array.isArray(cart.discount_codes)) {
        cart.discount_codes.forEach((dc) => {
          if (dc.code) {
            codes.push({ code: dc.code, title: dc.code });
          }
        });
      }

      return codes;
    }

    // Build the `discount` string for /cart/update.js from a list of codes
    // e.g. ['SAVE10','SHIPFREE'] -> 'SAVE10,SHIPFREE'
    function formatDiscountString(codes) {
      return codes.join(',');
    }

    // Render applied discount codes under the input
    function renderAppliedDiscounts(codes) {
      if (!codes.length) {
        appliedContainer.innerHTML = '';
        return;
      }

      const list = document.createElement('ul');
      list.className = 'applied-discount-list';

      codes.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'applied-discount-item';

        const codeSpan = document.createElement('span');
        codeSpan.className = 'applied-discount-code';
        codeSpan.textContent = item.code;

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'applied-discount-remove';
        removeBtn.setAttribute('aria-label', `Remove discount code ${item.code}`);
        removeBtn.textContent = '×'; // Remove icon

        removeBtn.addEventListener('click', () => {
          removeDiscountCode(item.code);
        });

        li.appendChild(codeSpan);
        li.appendChild(removeBtn);
        list.appendChild(li);
      });

      appliedContainer.innerHTML = '';
      appliedContainer.appendChild(list);
    }

    // Apply ALL discount codes to the cart via /cart/update.js
    function updateCartDiscounts(codes) {
      // check if the codes can not combine, return the applied codes that can be combined
      codes = codesCanNotCombineCheck(window.codesCanNotCombineArray, codes);

      const discountString = codes.length ? formatDiscountString(codes) : '';

      return fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          discount: discountString,
        }),
      }).then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw data;
          });
        }
        return response.json();
      });
    }

    function showMessage(message, error = false) {
      messageEl.textContent = message;
      messageEl.classList.remove('hidden');
      if (error) {
        messageEl.classList.add('error');
      } else {
        messageEl.classList.remove('error');
      }
      setTimeout(() => {
        messageEl.classList.add('hidden');
        messageEl.classList.remove('error');
      }, 4000);
    }

    // Remove a single code from the list and update the cart
    function removeDiscountCode(codeToRemove, message, error = false) {
      form.classList.add('loading');
      fetchCart()
        .then((cart) => {
          const codes = getDiscountCodesFromCart(cart).map((c) => c.code);
          const remaining = codes.filter((c) => c !== codeToRemove);

          return updateCartDiscounts(remaining);
        })
        .then((updatedCart) => {
          showMessage(message || `${codeToRemove} removed.`, error);

          const currentCodes = getDiscountCodesFromCart(updatedCart).map((c) => c.code);
          renderAppliedDiscounts(getDiscountCodesFromCart(updatedCart));

          // Optionally: refresh totals / cart UI from updatedCart
          console.log('Updated cart after removing code:', codeToRemove);

          // update discount summary
          const grouped = getGroupedDiscountsFromCart(updatedCart);
          renderDiscountSummary(summaryContainer, grouped);

          // refresh cart
          AlpFn.refreshCart('[data-ajax-cart]');

          form.classList.remove('loading');
        })
        .catch((error) => {
          console.error('Error removing discount:', error);
          showMessage('Unable to remove discount. Please try again.', true);
          form.classList.remove('loading');
          input.value = '';
        });
    }

    // --- Init: fetch cart and render applied codes --------------------------

    async function init(loading = true) {
      fetchCart()
        .then((cart) => {
          // const codes = getDiscountCodesFromCart(cart);
          // renderAppliedDiscounts(codes);
          if (loading) {
            form.classList.add('loading');
          } else {
            form.classList.add('updating');
          }
          let AllCodes = cart.discount_codes;
          let appliedCodes = [];
          AllCodes.forEach((code) => {
            if (code.applicable) {
              appliedCodes.push(code.code);
            }
          });
          appliedCodesToStr = appliedCodes.join(',');
          let updates = {
            discount: appliedCodesToStr,
          };
          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updates),
          })
            .then((response) => response.json())
            .then((data) => {
              // console.log(data);
              const codes = getDiscountCodesFromCart(data);
              renderAppliedDiscounts(codes);
              console.log('Applied discount codes:', codes);

              // update discount summary
              const grouped = getGroupedDiscountsFromCart(data);
              renderDiscountSummary(summaryContainer, grouped);

              form.classList.remove('loading');
              form.classList.remove('updating');
            });
        })
        .catch((err) => {
          console.error('Error fetching cart:', err);
          form.classList.remove('loading');
          form.classList.remove('updating');
        });
    }

    window.addEventListener('refreshAjaxCart', () => init(true));

    // add newCode
    function addNewCode(newCode) {
      form.classList.add('loading');
      // Strategy:
      // 1. Fetch current cart & existing codes
      // 2. Add new code to the list (if not already present)
      // 3. POST all codes as a single string to cart/update.js
      fetchCart()
        .then((cart) => {
          const existingCodes = getDiscountCodesFromCart(cart).map((c) => c.code.toLowerCase());

          const mergedCodes = [...new Set([...existingCodes, newCode.toLowerCase()])];

          return updateCartDiscounts(mergedCodes);
        })
        .then((updatedCart) => {
          // check if the discount is applicable, if not, show the error message and remove this discount code
          let thisCode = updatedCart.discount_codes.find((code) => code.code.toLowerCase() === newCode.toLowerCase());
          if (thisCode && !thisCode.applicable) {
            console.log('Discount is not applicable:', thisCode);
            removeDiscountCode(thisCode.code.toLowerCase(), `${thisCode.code} is not applicable.`, true);
            input.value = '';
            return;
          }

          // showMessage('Discount applied.');

          input.value = '';

          const codes = getDiscountCodesFromCart(updatedCart);
          renderAppliedDiscounts(codes);

          // update discount summary
          const grouped = getGroupedDiscountsFromCart(updatedCart);
          renderDiscountSummary(summaryContainer, grouped);

          // Optionally: re-render cart totals, etc.
          console.log('Updated cart with discount(s):', codes);

          // refresh line item discount summary and cart

          AlpFn.refreshCart('[data-ajax-cart]');

          form.classList.remove('loading');
        })
        .catch((error) => {
          console.error('Error applying discount:', error);
          showMessage('Unable to apply this discount.', true);
          form.classList.remove('loading');
          input.value = '';
        });
    }

    // codes can not combine
    function codesCanNotCombineCheck(codesNotCombineArray, appliedCodes) {
      codesNotCombineArray = codesNotCombineArray || [];
      appliedCodes = appliedCodes || [];

      if (codesNotCombineArray.length === 0 || appliedCodes.length === 0) {
        return appliedCodes;
      }

      let finalCodesToRemove = [];
      // for each codes in codesNotCombineArray, check if it is in appliedCodes
      for (let i = 0; i < codesNotCombineArray.length; i++) {
        if (appliedCodes.includes(codesNotCombineArray[i])) {
          finalCodesToRemove.push(codesNotCombineArray[i]);
        }
      }

      if (finalCodesToRemove.length > 1) {
        for (let i = 0; i < finalCodesToRemove.length; i++) {
          if (i > 0) {
            appliedCodes.splice(appliedCodes.indexOf(finalCodesToRemove[i]), 1);
          }
        }

        // show message
        // showMessage(`${finalCodesToRemove.join(', ')} are not combineable together.`);
        console.log('Codes Can Not Combine:', finalCodesToRemove);
        console.log('Final Applied Codes:', appliedCodes);
      }
      return appliedCodes;
    }

    // --- Form submit: apply a discount code ---------------------------------

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const newCode = input.value.trim();
      if (!newCode) {
        // showMessage('Please enter a discount code.');
        return;
      }

      addNewCode(newCode);
    });

    // discount-summary -----------------------------------

    // Build a friendly label from a discount_application / cart_level_discount_application
    function getDiscountLabel(app) {
      // Prefer a human-readable title; fallback to code; fallback to type
      return app.title || app.code || app.type || 'Discount';
    }

    // Returns array of { label, totalAmount } where totalAmount is a number (in shop currency)
    function getGroupedDiscountsFromCart(cart) {
      const groups = Object.create(null); // { [label]: totalAmountNumber }

      // 1) Line-item level discounts
      if (Array.isArray(cart.items)) {
        cart.items.forEach((item) => {
          if (!Array.isArray(item.line_level_discount_allocations)) return;

          item.line_level_discount_allocations.forEach((alloc) => {
            const app = alloc.discount_application || {};
            const label = getDiscountLabel(app);
            const amount = parseFloat(alloc.amount || '0') || 0;

            if (!groups[label]) {
              groups[label] = 0;
            }
            groups[label] += amount;
          });
        });
      }

      // 2) Cart-level discount applications
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((app) => {
          let thisApp = app.discount_application || app;
          // console.log('cart_level_discount_applications:', thisApp);
          if (thisApp.type === 'discount_code') {
            const label = getDiscountLabel(thisApp);
            const amount = parseFloat(thisApp.total_allocated_amount || '0') || 0;

            if (!groups[label]) {
              groups[label] = 0;
            }
            groups[label] += amount;
          }
        });
      }

      // Convert map → array
      return Object.keys(groups).map((label) => ({
        label,
        totalAmount: groups[label],
      }));
    }

    function formatMoneyFromNumber(amount) {
      // amount is a number in store currency (e.g. 5 -> $5.00)
      // Use Shopify's money formatting if needed; this simple example uses Intl
      // Adjust currency code and locale to your store.
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.shopCurrentCurrency,
      }).format(amount);
    }

    function renderDiscountSummary(container, discounts) {
      if (!container) return;

      if (!discounts.length) {
        container.innerHTML = '';
        return;
      }

      const list = document.createElement('ul');
      list.className = 'discount-summary-list';

      discounts.forEach((d) => {
        const li = document.createElement('li');
        li.className = 'discount-summary-item';

        const nameSpan = document.createElement('span');
        nameSpan.className = 'discount-summary-name';
        nameSpan.innerHTML = `${window.shopDiscountLabelSvgHtml} ${d.label}`;

        const amountSpan = document.createElement('span');
        amountSpan.className = 'discount-summary-amount';
        // Show as negative amount
        amountSpan.textContent = '-' + formatMoneyFromNumber(d.totalAmount / 100.0);

        li.appendChild(nameSpan);
        li.appendChild(amountSpan);
        list.appendChild(li);
      });

      container.innerHTML = '';
      container.appendChild(list);
    }

    window.refreshAjaxCartDiscountSummary = () => {
      fetchCart()
        .then((cart) => {
          const grouped = getGroupedDiscountsFromCart(cart);
          renderDiscountSummary(summaryContainer, grouped);
        })
        .catch((err) => {
          console.error('Error fetching cart for discounts:', err);
        });
    };

    init();
    // window.refreshAjaxCartDiscountSummary();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axx-line-item-discount-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    window.refreshLineItemDiscountSummary = async () => {
      await fetch('/')
        .then((response) => response.text())
        .then((responseHtml) => {
          let parser = new DOMParser();
          let responseDoc = parser.parseFromString(responseHtml, 'text/html');
          // rerender axx-line-item-discount
          let $axxLineItemDiscountContainer = responseDoc.querySelector(`.axx-line-item-discount-summary-wrapper`);
          let $axxLineItemDiscountWrapper = document.querySelector(`.axx-line-item-discount-summary-wrapper`);
          if ($axxLineItemDiscountContainer && $axxLineItemDiscountWrapper) {
            $axxLineItemDiscountWrapper.innerHTML = $axxLineItemDiscountContainer.innerHTML;
          }
          console.log('Line Item Discount Summary Refreshed');
        });
    };
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axx-variants-swatch"] && !Shopify.designMode) return;
  try {
    window.AXXVariantsSwatch = class {
    // 选择器 [data-axx-swatch]
    // 父级 [data-product-swatch]
    // 图片 [data-product-swatch-images]
    // 价格容器 [data-product-swatch-price]
    // 价格值 [data-product-swatch-price-value]
    // 对比价格 [data-product-swatch-compare-price-value]
    // url [data-product-swatch-url]

    constructor() {
      this.products = [];
      // 存储事件处理函数
      this.eventListeners = new Map();
    }

    init() {
      this.products = document.querySelectorAll('[data-axx-swatch]');
      this.products.forEach((product) => {
        let form = product.querySelector('form');
        // 创建事件处理函数
        const handler = (e) => this.handlerChange(product, form);
        // 存储事件处理函数
        this.eventListeners.set(form, handler);
        // 添加事件监听器
        form.addEventListener('change', handler);
      });
    }

    update() {
      this.products.forEach((product) => {
        let form = product.querySelector('form');
        // 获取存储的事件处理函数
        const handler = this.eventListeners.get(form);
        if (handler) {
          // 移除事件监听器
          form.removeEventListener('change', handler);
          // 清理存储的引用
          this.eventListeners.delete(form);
        }
      });
      this.products = [];
      this.init();
    }

    handlerChange(product, form) {
      const fieldsets = Array.from(form.querySelectorAll('[data-form-input]'));
      let options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
      this.updateCurrentVariant(product, options);
    }

    areArraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      const sortedArr1 = [...arr1].sort();
      const sortedArr2 = [...arr2].sort();
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          return false;
        }
      }
      return true;
    }

    getVariantData(product) {
      let variantData = JSON.parse(product.querySelector('[type="application/json"]').textContent);
      return variantData;
    }

    updateCurrentVariant(product, options) {
      let currentVariant = null;
      this.getVariantData(product).find((variant) => {
        // match the current variant
        if (this.areArraysEqual(variant.options, options)) {
          currentVariant = variant;
        }
      });
      // console.log(currentVariant.id);
      if (currentVariant) {
        this.setProductInfo(product, currentVariant);
        this.updateVariantStatuses(product, currentVariant);
      }
    }

    updateVariantStatuses(product, currentVariant) {
      let $this = this;
      let forms = product.querySelector('form').querySelectorAll('[data-form-input]');
      if (forms.length < 2) {
        return;
      }
      // Disable all inputs
      forms.forEach((form) => {
        form.querySelectorAll('input').forEach((input) => {
          input.classList.add('disabled');
        });
      });
      // Enable only the matched inputs
      forms.forEach((form, index) => {
        let checkedInput = form.querySelector(':checked');
        let matchedVariants = $this
          .getVariantData(product)
          .filter((variant) => variant.options[index] === checkedInput.value);
        // console.log(matchedVariants);
        matchedVariants.forEach((variant) => {
          let available = variant.available;
          variant.options.forEach((option, optionIndex) => {
            if (optionIndex !== index) {
              // console.log(option);
              let optionInputs = forms[optionIndex].querySelectorAll(`input[value="${option}"]`);
              optionInputs.forEach((input) => {
                if (available) {
                  input.classList.remove('disabled');
                }
              });
            }
          });
        });
      });
    }

    setProductInfo(product, variant) {
      let productId = product.dataset.productId;
      let productUrl = product.dataset.productUrl;
      let productUrlWithVariant = productUrl + '?variant=' + variant.id;
      let productInfo = {
        id: variant.id,
        price: variant.price,
        compare_at_price: variant.compare_at_price,
        image: variant.featured_image.src,
        image_id: variant.featured_image.id,
        url: productUrlWithVariant,
        options: variant.options,
        available: variant.available,
      };
      this.updateProductInfo(product, productId, productInfo);
      this.sendCustomEvent(product, productId, 'variant:change', productInfo);
      // console log
      console.log(`SwatchChanged:[product:${productId}],[variant:${variant.id}]`);
    }

    updateProductInfo(product, productId, productInfo) {
      // match the parent element '[data-product-swatch]'
      let parent = product.closest('[data-product-swatch]');
      // update product data info
      if (parent) {
        parent.dataset.productInfo = JSON.stringify(productInfo);
        // update images src and srcset
        let images = parent.querySelectorAll(`[data-product-swatch-images]`);
        if (images) {
          images.forEach((image) => {
            let imageInfo = JSON.parse(image.querySelector('[type="application/json"]').textContent);
            imageInfo.variants.forEach((variant) => {
              if (variant.id === productInfo.id) {
                image.querySelector('img').src = variant.image.src;
                image.querySelector('img').srcset = variant.image.srcset;
              }
            });
          });
        }
        // update price
        let priceWarpper = parent.querySelectorAll('[data-product-swatch-price]');
        if (priceWarpper) {
          priceWarpper.forEach((price) => {
            let the_price = price.querySelector('[data-product-swatch-price-value]');
            let the_compare_price = price.querySelector('[data-product-swatch-compare-price-value]');
            let priceInfo = JSON.parse(price.querySelector('[type="application/json"]').textContent);
            priceInfo.variants.forEach((variant) => {
              if (variant.id === productInfo.id) {
                the_price.textContent = variant.price;
                the_compare_price.textContent = variant.compare_at_price;
                if (variant.compare_at_price) {
                  the_compare_price.classList.remove('hidden');
                } else {
                  the_compare_price.classList.add('hidden');
                }
              }
            });
          });
        }
        // update url
        let urlWarpper = parent.querySelectorAll('[data-product-swatch-url]');
        if (urlWarpper) {
          urlWarpper.forEach((url) => {
            url.setAttribute('href', productInfo.url);
          });
        }
      }
    }

    sendCustomEvent(product, productId, eventName, detail) {
      let parent = product.closest('[data-product-swatch]');
      if (parent) {
        let event = new CustomEvent(eventName, { detail });
        parent.dispatchEvent(event);
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.axxVariantsSwatch = new window.AXXVariantsSwatch();
    window.axxVariantsSwatch.init();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-auto-click-gtranslate"] && !Shopify.designMode) return;
  try {
    function autoClickGtranslate() {
    const LANG_MAP = {
      de: 'de',
      fr: 'fr',
      nl: 'nl',
      it: 'it',
      es: 'es',
      pt: 'pt',
      en: 'en',
      pl: 'pl',
      sv: 'sv',
      da: 'da',
      fi: 'fi',
      no: 'no',
      cs: 'cs',
      hu: 'hu',
      ro: 'ro',
      el: 'el',
      tr: 'tr',
      ru: 'ru',
      ja: 'ja',
      ko: 'ko',
      zh: 'zh-CN',
      ar: 'ar',
      he: 'he',
      th: 'th',
      vi: 'vi',
      id: 'id',
      uk: 'uk',
      sk: 'sk',
      hr: 'hr',
      sl: 'sl',
      lt: 'lt',
      lv: 'lv',
      et: 'et',
      bg: 'bg',
    };

    function toDefaultLanguage() {
      setTimeout(() => {
        document.querySelector(`[data-gt-lang="en"]`)?.click();
      }, 1000);
    }

    const pathSegment = window.location.pathname.split('/').filter(Boolean)[0];
    if (!pathSegment || pathSegment === undefined) {
      toDefaultLanguage();
      return;
    }

    const langKey = pathSegment.toLowerCase().split('-')[0];
    const gtLang = LANG_MAP[langKey];
    if (!gtLang) {
      toDefaultLanguage();
      return;
    }

    const langButton = document.querySelector(`[data-gt-lang="${gtLang}"]`);
    if (langButton) {
      langButton.click();
    }
  }
  window.addEventListener('load', () => {
    autoClickGtranslate();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-360-viewer-popup"] && !Shopify.designMode) return;
  try {
    class LX360Viewer extends HTMLElement {
    static TOTAL_STEPS = 720;

    constructor() {
      super();
      this._realIndex = 0;
      this._currentStep = 0;
      this._ratio = 1;
      this._onOpen = this.handleOpenClick.bind(this);
      this._onClose = this.handleClose.bind(this);
      this._onOutsideClick = this.handleOutsideClick.bind(this);
      this._onUpdateViewer = this.handleUpdateViewer.bind(this);
    }

    connectedCallback() {
      this.imageNumber = Number(this.dataset.imageNumber) || 0;
      this.defaultImage = Number(this.dataset.defaultImage) || 0;

      if (this.imageNumber <= 0) return;

      this.openBtn = this.querySelector('.lx-v360-viewer__open');
      this.overlay = this.querySelector('.lx-v360-viewer__overlay');
      this.stage = this.querySelector('.lx-v360-viewer__stage');
      this.tips = this.querySelector('.lx-v360-viewer__tips');
      this.frames = this.querySelectorAll('.lx-v360-viewer__frame');

      this._ratio = LX360Viewer.TOTAL_STEPS / this.imageNumber;
      this._realIndex = Math.min(this.defaultImage, this.frames.length - 1);
      this._currentStep = this._realIndex * this._ratio;

      this.overlay?.classList.add('lx-v360-viewer__overlay--hidden');

      this.openBtn?.addEventListener('click', this._onOpen);
      this.querySelector('.lx-v360-viewer__close')?.addEventListener('click', this._onClose);
      window.addEventListener('updateViewer', this._onUpdateViewer);

      this.setActiveFrame(this._realIndex);
      this.waitForObserverAndInit();
    }

    disconnectedCallback() {
      this.openBtn?.removeEventListener('click', this._onOpen);
      this.querySelector('.lx-v360-viewer__close')?.removeEventListener('click', this._onClose);
      window.removeEventListener('updateViewer', this._onUpdateViewer);
      this.unbindOutsideClick();
      this._observer?.kill();
      this._observer = null;
    }

    isOpen() {
      return this.overlay?.classList.contains('lx-v360-viewer__overlay--active') ?? false;
    }

    bindOutsideClick() {
      requestAnimationFrame(() => {
        document.addEventListener('click', this._onOutsideClick, true);
      });
    }

    unbindOutsideClick() {
      document.removeEventListener('click', this._onOutsideClick, true);
    }

    handleOpenClick(event) {
      event.stopPropagation();
      this.handleOpen();
    }

    handleOutsideClick(event) {
      if (!this.isOpen() || this.contains(event.target)) return;
      this.handleClose();
    }

    waitForObserverAndInit(attempt = 0) {
      const Observer = window.gsap?.Observer || window.Observer;
      if (Observer && this.stage) {
        window.gsap?.registerPlugin?.(Observer);
        this.initObserver(Observer);
        return;
      }
      if (attempt > 50) return;
      requestAnimationFrame(() => this.waitForObserverAndInit(attempt + 1));
    }

    initObserver(Observer) {
      this._observer = Observer.create({
        target: this.stage,
        type: 'touch,pointer',
        onDrag: (self) => this.updateStep(self.deltaX),
        onDragStart: () => {
          this.tips?.classList.add('lx-v360-viewer__tips--hidden');
          this.classList.add('lx-v360-viewer--dragging');
        },
        onDragEnd: () => {
          this.tips?.classList.remove('lx-v360-viewer__tips--hidden');
          this.classList.remove('lx-v360-viewer--dragging');
        },
      });
    }

    setActiveFrame(index) {
      this.frames.forEach((frame, i) => {
        frame.classList.toggle('lx-v360-viewer__frame--active', i === index);
      });
    }

    updateStep(deltaX) {
      this._currentStep = Math.round(this._currentStep + deltaX);

      if (this._currentStep < 0) {
        this._currentStep = LX360Viewer.TOTAL_STEPS;
      } else if (this._currentStep > LX360Viewer.TOTAL_STEPS) {
        this._currentStep = 0;
      }

      this._realIndex = Math.round(this._currentStep / this._ratio);
      this.setActiveFrame(this._realIndex);
    }

    handleUpdateViewer() {
      this.setActiveFrame(this._realIndex);
    }

    handleOpen() {
      if (!this.overlay) return;

      this.overlay.classList.remove('lx-v360-viewer__overlay--hidden');
      window.lazyLoadInstance?.update?.();

      requestAnimationFrame(() => {
        this.overlay.classList.add('lx-v360-viewer__overlay--active', 'lx-v360-viewer__overlay--loaded');
      });

      this.openBtn?.classList.add('lx-v360-viewer__open--hidden');
      this.bindOutsideClick();
    }

    handleClose() {
      if (!this.overlay) return;

      this.unbindOutsideClick();
      this.overlay.classList.remove('lx-v360-viewer__overlay--active');
      this.openBtn?.classList.remove('lx-v360-viewer__open--hidden');

      setTimeout(() => {
        this.overlay.classList.add('lx-v360-viewer__overlay--hidden');
        this.overlay.classList.remove('lx-v360-viewer__overlay--loaded');
      }, 600);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('lx-360-viewer')) {
      customElements.define('lx-360-viewer', LX360Viewer);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-buy-buttons"] && !Shopify.designMode) return;
  try {
    class LXSubmitButton extends HTMLElement {
    constructor() {
      super();
      this.handleSubmit = this.handleSubmit.bind(this);
      this.AdditionalProductsAddCart = this.AdditionalProductsAddCart.bind(this);
    }

    connectedCallback() {
      this.form = this.closest('form');
      this.button = this.querySelector('[data-lx-add-to-cart-button]');
      this.variantInput = this.querySelector('[name="id"]');

      if (!this.form || !this.button) return;

      this.form.addEventListener('submit', this.handleSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit);
    }

    getShopifyRoot() {
      return window.Shopify?.routes?.root || '/';
    }

    setLoading(loading) {
      if (!this.button) return;

      this.button.classList.toggle('loading', loading);

      if (loading) {
        this.button.setAttribute('aria-disabled', 'true');
        this.button.disabled = true;
        return;
      }

      const variantAvailable = this.variantInput && !this.variantInput.disabled;
      this.button.disabled = !variantAvailable;
      if (variantAvailable) {
        this.button.removeAttribute('aria-disabled');
      } else {
        this.button.setAttribute('aria-disabled', 'true');
      }
    }

    AdditionalProductsAddCart() {
      const items = [];

      document.querySelectorAll('[data-addional-product].selected').forEach((el) => {
        const variantId = el.querySelector('select')?.value;
        if (variantId) items.push({ id: variantId });
      });
      document.querySelectorAll('[data-promotion-pack].selected').forEach((el) => {
        const variantId = el.getAttribute('data-pack-variant');
        if (variantId) items.push({ id: variantId });
      });
      document.querySelectorAll('[data-compatible-product].selected').forEach((el) => {
        const variantId = el.getAttribute('data-compatible-variant');
        if (variantId) items.push({ id: variantId });
      });

      return items;
    }

    getFormQuantity() {
      const quantityInput = this.form?.querySelector('lx-quantity-input [name="quantity"]');
      const quantity = Number(quantityInput?.value || 1);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    getFormProperties() {
      if (!this.form) return {};

      const properties = {};
      const formData = new FormData(this.form);

      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') {
          properties[match[1]] = value;
        }
      }

      return properties;
    }

    buildCartItems(variantId, quantity) {
      const items = [
        {
          id: variantId,
          quantity,
          properties: this.getFormProperties(),
        },
      ];

      this.AdditionalProductsAddCart().forEach((item) => {
        items.push({
          id: item.id,
          quantity,
          properties: item.properties || {},
        });
      });

      return items;
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (!this.form || !this.button || this.button.disabled) return;

      const variantId = this.variantInput?.value;
      if (!variantId || this.variantInput?.disabled) return;

      this.setLoading(true);
      this.form.classList.add('ajaxForm', 'loading');

      try {
        const quantity = this.getFormQuantity();
        const cartItems = this.buildCartItems(variantId, quantity);

        let response;
        if (typeof AlpFn !== 'undefined' && typeof AlpFn.AddToCartMulti === 'function') {
          response = await AlpFn.AddToCartMulti(cartItems);
        } else {
          const formData = new FormData(this.form);
          response = await fetch(`${this.getShopifyRoot()}cart/add.js`, {
            method: 'POST',
            body: formData,
          });
        }

        if (!response || response === false) {
          throw new Error('Add to cart failed');
        }

        const data = await response
          .clone()
          .json()
          .catch(() => ({}));

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        if (typeof AlpFn !== 'undefined' && typeof AlpFn.refreshCart === 'function') {
          await AlpFn.refreshCart('[data-ajax-cart]', response);
          document.body.classList.add('cart-open');
          const cartDrawer = document.querySelector('[data-ajax-cart]');
          setTimeout(() => {
            cartDrawer?.classList.add('open');
            document.body.classList.add('noscroll');
          }, 50);
        } else if (window.routes?.cart_url) {
          window.location = window.routes.cart_url;
        }

        this.dispatchEvent(
          new CustomEvent('lx-add-to-cart:success', {
            bubbles: true,
            detail: { variantId, cartItem: data },
          })
        );
      } catch (error) {
        console.error('[lx-submit-button]', error);
        this.dispatchEvent(
          new CustomEvent('lx-add-to-cart:error', {
            bubbles: true,
            detail: { message: error?.message || 'Add to cart failed' },
          })
        );
      } finally {
        this.form?.classList.remove('loading');
        this.setLoading(false);
        this.dispatchEvent(
          new CustomEvent('lx-add-to-cart:finished', {
            bubbles: true,
            detail: { message: 'Add to cart Finished' },
          })
        );
      }
    }
  }

  if (!customElements.get('lx-submit-button')) {
    customElements.define('lx-submit-button', LXSubmitButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-quantity-input"] && !Shopify.designMode) return;
  try {
    class LxQuantityInput extends HTMLElement {
    constructor() {
      super();
      this.field = this.querySelector('.lx-quantity-input__field');
      this.decreaseBtn = this.querySelector('[data-lx-qty-action="decrease"]');
      this.increaseBtn = this.querySelector('[data-lx-qty-action="increase"]');
      this.onFieldChange = this.onFieldChange.bind(this);
      this.onButtonClick = this.onButtonClick.bind(this);
    }

    connectedCallback() {
      if (!this.field) return;

      this.field.addEventListener('change', this.onFieldChange);
      this.field.addEventListener('blur', this.onFieldChange);
      this.decreaseBtn?.addEventListener('click', this.onButtonClick);
      this.increaseBtn?.addEventListener('click', this.onButtonClick);

      this.syncValue();
      this.syncButtons();
    }

    disconnectedCallback() {
      this.field?.removeEventListener('change', this.onFieldChange);
      this.field?.removeEventListener('blur', this.onFieldChange);
      this.decreaseBtn?.removeEventListener('click', this.onButtonClick);
      this.increaseBtn?.removeEventListener('click', this.onButtonClick);
    }

    getRules() {
      const min = parseInt(this.field.dataset.lxQtyMin || this.field.min, 10) || 1;
      const step = parseInt(this.field.dataset.lxQtyStep || this.field.step, 10) || 1;
      const maxAttr = this.field.dataset.lxQtyMax || this.field.max;
      const max = maxAttr === '' || maxAttr == null ? null : parseInt(maxAttr, 10);
      return { min, step, max };
    }

    clampValue(rawValue) {
      const { min, step, max } = this.getRules();
      let value = parseInt(rawValue, 10);

      if (Number.isNaN(value)) value = min;

      if (value < min) value = min;

      if (max != null && value > max) value = max;

      const offset = (value - min) % step;
      if (offset !== 0) {
        value = value - offset;
        if (value < min) value = min;
      }

      return value;
    }

    syncValue() {
      this.field.value = String(this.clampValue(this.field.value));
    }

    syncButtons() {
      const { min, max } = this.getRules();
      const value = parseInt(this.field.value, 10);

      if (this.decreaseBtn) {
        this.decreaseBtn.disabled = value <= min;
      }

      if (this.increaseBtn) {
        this.increaseBtn.disabled = max != null && value >= max;
      }
    }

    onFieldChange() {
      this.syncValue();
      this.syncButtons();
    }

    onButtonClick(event) {
      event.preventDefault();
      const action = event.currentTarget?.dataset?.lxQtyAction;
      const { min, step, max } = this.getRules();
      let value = this.clampValue(this.field.value);

      if (action === 'increase') {
        value += step;
        if (max != null && value > max) value = max;
      } else {
        value -= step;
        if (value < min) value = min;
      }

      this.field.value = String(value);
      this.field.dispatchEvent(new Event('change', { bubbles: true }));
      this.syncButtons();
    }
  }

  if (!customElements.get('lx-quantity-input')) {
    customElements.define('lx-quantity-input', LxQuantityInput);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-search-predictive"] && !Shopify.designMode) return;
  try {
    class LXSearchPredictive extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('#PredictiveSearchInput');
      this.optionRoot = this.querySelector('#PredictiveSearchOption');
      this.optionCurrent = this.querySelector('.lx-search-predictive__option_current');
      this.optionList = this.querySelector('.lx-search-predictive__option_list');
      this.optionItems = [...this.querySelectorAll('.lx-search-predictive__option_item')];
      this.selectedTag = '';
      this.typeMap = ['products', 'collections', 'pages', 'articles'];
      this.activeType = this.typeMap[0];
      this.hasSearchResults = false;

      this.resultsContainer = this.querySelector('.lx-search-predictive__results');
      this.predictiveSearchUrl = this.resultsContainer?.dataset.predictiveUrl || '/search/suggest';
      this.sectionId = this.resultsContainer?.dataset.sectionId || 'lx-predictive-search-result';

      this.debouncedSearch = this.debounce(this.fetchPredictiveSearch.bind(this), 220);
      this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
      this.onResultsClick = this.onResultsClick.bind(this);
    }

    connectedCallback() {
      if (!this.input || !this.resultsContainer) return;

      document.addEventListener('pointerdown', this.onDocumentPointerDown, true);
      this.resultsContainer.addEventListener('click', this.onResultsClick);

      this.input.addEventListener('focus', () => this.syncResultsContainerActive());
      this.input.addEventListener('input', (event) => {
        const keyword = event.target.value.trim();
        if (!keyword) {
          this.resetResults();
          return;
        }
        this.debouncedSearch(keyword);
      });

      if (this.optionRoot && this.optionCurrent) {
        this.optionCurrent.addEventListener('click', (event) => {
          event.stopPropagation();
          this.optionList?.classList.toggle('active');
          this.optionRoot?.classList.toggle('open');
        });

        this.optionItems.forEach((item) => {
          item.addEventListener('click', (event) => {
            event.stopPropagation();
            const raw = (item.dataset.value || '').trim();
            this.selectedTag = raw.toLowerCase();

            // 先把所有选项的 active 清掉，再给当前点击项加上 active。
            this.optionItems.forEach((option) => option.classList.remove('active'));
            item.classList.add('active');

            this.optionCurrent.querySelector('span').textContent = item.textContent.trim() || 'All';
            this.optionList?.classList.remove('active');
            this.optionRoot?.classList.remove('open');

            const keyword = this.input.value.trim();
            if (!keyword) return;
            this.debouncedSearch(keyword);
          });
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.onDocumentPointerDown, true);
      this.resultsContainer?.removeEventListener('click', this.onResultsClick);
    }

    onDocumentPointerDown(event) {
      if (!this.resultsContainer) return;
      if (this.contains(event.target)) {
        if (this.optionRoot && !this.optionRoot.contains(event.target)) {
          this.optionList?.classList.remove('active');
          this.optionRoot?.classList.remove('open');
        }
        return;
      }
      this.optionList?.classList.remove('active');
      this.optionRoot?.classList.remove('open');
      this.resultsContainer.classList.remove('active');
    }

    onResultsClick(event) {
      const tab = event.target.closest('.lx-search-predictive__tab');
      if (tab) {
        this.activateType(tab.dataset.type || '');
        return;
      }

      const queryLink = event.target.closest('.lx-search-predictive__queries-link');
      if (!queryLink || !this.input) return;
      const queryText = (queryLink.dataset.query || '').trim();
      if (!queryText) return;

      event.preventDefault();
      this.input.value = queryText;
      this.input.focus();
      this.debouncedSearch(queryText);
    }

    getSelectedTag() {
      return (this.selectedTag || '').trim().toLowerCase();
    }

    getRenderedTabs() {
      return [...this.resultsContainer.querySelectorAll('.lx-search-predictive__tab')];
    }

    getRenderedPanels() {
      return [...this.resultsContainer.querySelectorAll('.lx-search-predictive__result')];
    }

    syncResultsContainerActive() {
      if (!this.resultsContainer || !this.input) return;
      const hasKeyword = this.input.value.trim().length > 0;
      // this.resultsContainer.classList.toggle('active', hasKeyword && this.hasSearchResults);
      this.resultsContainer.classList.toggle('active', hasKeyword);
    }

    debounce(callback, delay = 200) {
      let timer;
      return (...args) => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => callback(...args), delay);
      };
    }

    activateType(type) {
      this.activeType = type || this.activeType;
      const tabs = this.getRenderedTabs();
      const panels = this.getRenderedPanels();

      tabs.forEach((tab) => {
        const isActive = !tab.hidden && tab.dataset.type === this.activeType;
        tab.classList.toggle('active', isActive);
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.type === this.activeType;
        panel.hidden = !isActive;
        panel.classList.toggle('active', isActive);
      });
    }

    deactivateAllTabs() {
      this.getRenderedTabs().forEach((tab) => tab.classList.remove('active'));
      this.getRenderedPanels().forEach((panel) => {
        panel.classList.remove('active');
        panel.hidden = true;
      });
    }

    resetResults() {
      this.hasSearchResults = false;
      this.resultsContainer.classList.remove('active');
      this.resultsContainer.innerHTML = '';
      this.selectedTag = '';
      this.activeType = this.typeMap[0];
      this.optionList?.classList.remove('active');
      this.optionRoot?.classList.remove('open');
      if (this.optionCurrent) this.optionCurrent.querySelector('span').textContent = 'All';
    }

    async fetchPredictiveSearch(keyword) {
      const params = new URLSearchParams({
        q: keyword,
        'resources[type]': 'product,collection,page,article,query',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        section_id: this.sectionId,
      });

      const response = await fetch(`${this.predictiveSearchUrl}?${params.toString()}`);
      const text = await response.text();
      if (!response.ok) {
        this.hasSearchResults = false;
        this.syncResultsContainerActive();
        return;
      }

      const parsed = new DOMParser().parseFromString(text, 'text/html');
      const sectionRoot = parsed.querySelector(`#shopify-section-${this.sectionId}`);
      const renderedResults = sectionRoot?.querySelector('#lx-predictive-search-results');
      this.resultsContainer.innerHTML = renderedResults ? renderedResults.outerHTML : '';

      this.applyTagFilter();
      this.syncTabVisibilityAndActive();
      this.syncResultsContainerActive();
    }

    applyTagFilter() {
      const selectedTag = this.getSelectedTag();
      this.typeMap.forEach((type) => {
        if (type !== 'products' && type !== 'articles') return;
        const panel = this.resultsContainer.querySelector(`.lx-search-predictive__result[data-type="${type}"]`);
        const items = panel ? [...panel.querySelectorAll('.lx-search-predictive__result-item')] : [];

        items.forEach((item) => {
          if (!selectedTag) {
            item.hidden = false;
            return;
          }
          const tags = (item.dataset.tags || '')
            .split('|')
            .map((tag) => tag.trim().toLowerCase())
            .filter(Boolean);
          item.hidden = !tags.includes(selectedTag);
        });
      });
    }

    syncTabVisibilityAndActive() {
      /** @type {Record<string, boolean>} */
      const presence = {};

      this.typeMap.forEach((type) => {
        const panel = this.resultsContainer.querySelector(`.lx-search-predictive__result[data-type="${type}"]`);
        const visibleCount = panel
          ? [...panel.querySelectorAll('.lx-search-predictive__result-item')].filter((item) => !item.hidden).length
          : 0;
        presence[type] = visibleCount > 0;

        const tab = this.resultsContainer.querySelector(`.lx-search-predictive__tab[data-type="${type}"]`);
        if (tab) {
          tab.hidden = !presence[type];
          tab.toggleAttribute('aria-hidden', !presence[type]);
        }
      });

      const activeTab = this.getRenderedTabs().find((tab) => tab.classList.contains('active') && !tab.hidden);
      let nextType =
        activeTab && presence[activeTab.dataset.type || ''] ? activeTab.dataset.type || '' : this.activeType;
      if (!nextType || !presence[nextType]) {
        nextType = this.typeMap.find((type) => presence[type]) || '';
      }

      if (nextType) {
        this.activateType(nextType);
      } else {
        this.deactivateAllTabs();
      }

      const queryCount = this.resultsContainer.querySelectorAll('.lx-search-predictive__queries-item').length;
      this.hasSearchResults = this.typeMap.some((type) => presence[type]) || queryCount > 0;
    }
  }

  if (!customElements.get('lx-search-predictive')) {
    customElements.define('lx-search-predictive', LXSearchPredictive);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-variant-selector-v1"] && !Shopify.designMode) return;
  try {
    class LXVariantSelectorV1 extends HTMLElement {
    constructor() {
      super();
      this._onFormChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;

      this.variantsScript = this.form.querySelector('script[type="application/json"]');
      this.variants = this.parseVariants();

      this.form.addEventListener('change', this._onFormChange);
      this.syncRadiosFromVariantId(this.dataset.productVariantId);
      this.applyCurrentVariant(true);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this._onFormChange);
    }

    parseVariants() {
      if (!this.variantsScript?.textContent) return [];
      try {
        const data = JSON.parse(this.variantsScript.textContent);
        return Array.isArray(data) ? data : [];
      } catch {
        return [];
      }
    }

    /** 按 option position 顺序读取当前选中的选项值（与 JSON 里 option1/2/3 对齐） */
    getOptionGroups() {
      const root = this.querySelector('.lx-variant-selector__options');
      if (!root) return [];

      return Array.from(root.querySelectorAll('.lx-variant-selector__option')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    }

    getSelectedOptionValues() {
      return this.getOptionGroups().map((group) => {
        const input = group.querySelector('input[type="radio"]:checked');
        return input ? input.value : null;
      });
    }

    variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues) {
      if (variant[`option${posIndex + 1}`] !== candidateValue) return false;

      for (let j = 0; j < selectedValues.length; j += 1) {
        if (j === posIndex) continue;
        const sel = selectedValues[j];
        if (sel == null || sel === '') continue;
        if (variant[`option${j + 1}`] !== sel) return false;
      }

      return true;
    }

    /**
     * 当前选中值下，该维度取 candidateValue、其余维度沿用 selectedValues 时的组合状态。
     * selectedValues 中未选维度（null）不参与约束。
     * 返回 canPurchase、currentVariantNull（无变体行匹配该组合，例如仅有 Standard/Jungle Camo 而无 Large/Jungle Camo）。
     */
    hasAvailableVariantForCandidate(posIndex, candidateValue, selectedValues) {
      let hasAnyVariant = false;
      let hasAvailableVariant = false;

      for (const variant of this.variants) {
        if (!this.variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues)) continue;
        hasAnyVariant = true;
        if (variant.available === true) hasAvailableVariant = true;
      }

      return {
        currentVariantNull: !hasAnyVariant,
        canPurchase: hasAvailableVariant,
      };
    }

    /**
     * 根据当前各组选中项，更新每组内 radio。
     * - 组合在 JSON 中不存在（currentVariantNull）：始终对非当前选中项设置 disabled，忽略 canDisableInputSelection。
     * - 组合存在但售罄：仅当 data-can-disable-input-selection 为 true 时设置 disabled。
     * 已选中的项不 disabled，避免无法改选。
     */
    updateVariantStatuses() {
      if (!this.form || !this.variants.length) return;

      const selectedValues = this.getSelectedOptionValues();
      const groups = this.getOptionGroups();
      const allowDisableForSoldOut = this.dataset.canDisableInputSelection === 'true';

      groups.forEach((group, posIndex) => {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const { currentVariantNull, canPurchase } = this.hasAvailableVariantForCandidate(
            posIndex,
            input.value,
            selectedValues
          );

          let nativeDisabled = false;
          if (!input.checked) {
            if (currentVariantNull) {
              nativeDisabled = true;
            } else if (allowDisableForSoldOut && !canPurchase) {
              nativeDisabled = true;
            }
          }

          // input.disabled = nativeDisabled;
          input.classList.toggle('unavailable', nativeDisabled);
          input.parentElement.classList.toggle('unavailable', nativeDisabled);

          input.classList.toggle('disabled', currentVariantNull || !canPurchase);
        });
      });
    }

    findVariantByOptions(selectedValues) {
      if (!this.variants.length || selectedValues.some((v) => v == null || v === '')) {
        return null;
      }

      return (
        this.variants.find((variant) =>
          selectedValues.every((val, index) => {
            const key = `option${index + 1}`;
            return variant[key] === val;
          })
        ) || null
      );
    }

    syncRadiosFromVariant(variant) {
      if (!variant || !this.form) return;

      const groups = this.getOptionGroups();
      groups.forEach((group, index) => {
        const targetValue = variant[`option${index + 1}`];
        if (targetValue == null) return;

        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === targetValue;
        });
      });
    }

    findBestComposableVariant(changedPosIndex, changedValue, selectedValues) {
      const candidates = this.variants.filter((variant) => variant[`option${changedPosIndex + 1}`] === changedValue);
      if (!candidates.length) return null;

      const getScore = (variant) => {
        let score = variant.available ? 100 : 0;
        for (let i = 0; i < selectedValues.length; i += 1) {
          if (i === changedPosIndex) continue;
          const selected = selectedValues[i];
          if (selected && variant[`option${i + 1}`] === selected) score += 1;
        }
        return score;
      };

      let best = candidates[0];
      let bestScore = getScore(best);
      for (let i = 1; i < candidates.length; i += 1) {
        const current = candidates[i];
        const score = getScore(current);
        if (score > bestScore) {
          best = current;
          bestScore = score;
        }
      }

      return best;
    }

    syncRadiosFromVariantId(variantId) {
      if (!variantId || !this.variants.length) return;

      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      for (let i = 1; i <= 3; i += 1) {
        const val = variant[`option${i}`];
        if (val == null) continue;

        const inputs = this.form.querySelectorAll(`input[type="radio"][name="option-${i}"]`);
        inputs.forEach((input) => {
          input.checked = input.value === val;
        });
      }
    }

    updateProductInfo(variant, available = true) {
      // match element by [data-product-card] or [data-product-info]
      const productElement = this.closest('[data-product-card]') || this.closest('[data-product-info]');
      if (!productElement) return;
      //   update variant available
      productElement.dataset.variantAvailable = available;
      // update product variant id
      productElement.dataset.productVariantId = available ? String(variant.id) : '';
      // update add variant, match element by [data-add-variant]
      productElement.querySelectorAll('[data-add-variant]').forEach((element) => {
        element.dataset.addVariant = available ? String(variant.id) : '';
      });
      // update product link, match element by [data-product-link]
      productElement.querySelectorAll('[data-product-link]').forEach((element) => {
        element.href = available ? `${this.dataset.productUrl}?variant=${variant.id}` : `${this.dataset.productUrl}`;
      });
      // update product image, match element by [data-product-image]
      if (variant) {
        const imageWidth = Math.max(320, Math.min(800, window.innerWidth * 1.5));
        productElement.querySelectorAll('[data-product-image]').forEach((element) => {
          element.src = `${variant.featured_image.src}&width=${imageWidth}`;
        });
      }
      // update product price, match element by [data-product-price-element]
      if (variant) {
        productElement.querySelectorAll('[data-product-price-element]').forEach((element) => {
          this.updatePrice(variant, element);
        });
      }
    }

    updateProductDetail(variant, available = true) {
      const productDetail = this.closest('[data-product-detail]');
      if (!productDetail) return;
      // update product variant id
      productDetail.dataset.variantId = available ? String(variant.id) : '';
      productDetail.dataset.available = available;
      // update product price, match element by [data-product-price-element]
      if (variant) {
        productDetail.querySelectorAll('[data-product-price-element]').forEach((element) => {
          this.updatePrice(variant, element);
        });
      }
      // update product buy buttons without fetch, match element by [data-product-buy-buttons-element]
      if (variant) {
        productDetail.querySelectorAll('[data-product-buy-buttons-element]').forEach((element) => {
          let inputId = element.querySelector(`[name="id"]`);
          let submitButton = element.querySelector(`[type="submit"]`);
          if (inputId && submitButton) {
            inputId.value = String(variant.id);
            // set [name="id"] disabled
            inputId.disabled = !available;
            submitButton.disabled = !available;
            // set text with data-add-to-cart-text or data-sold-out-text
            submitButton.querySelector(`span`).textContent = available
              ? window.variantStrings.addToCart
              : window.variantStrings.soldOut;
          }
        });
      }
      // updata url use push state with custom parm
      const customParm = productDetail.dataset.customParm;
      let url = `${window.location.pathname}`;
      if (customParm) {
        url = `${url}?${variant ? `variant=${variant.id}&` : ''}${customParm}`;
        window.history.replaceState({ path: url }, '', url);
      } else {
        url = `${url}?${variant ? `variant=${variant.id}` : ''}`;
        window.history.replaceState({ path: url }, '', url);
      }
      // fetch product detail then dispatchEvent
      if (!variant) return;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.dispatchEvent(
            new CustomEvent('lx-variant-selector-v1:product-detail-updated', {
              bubbles: true,
              detail: { html, variant },
            })
          );
          // update product shipping time, match element by [data-product-shipping-time-element]
          this.replaceElementWrapper(productDetail, html, '[data-product-shipping-time-element]');
          // update product properties, match element by [data-product-properties-element]
          this.replaceElementWrapper(productDetail, html, '[data-product-properties-element]');
        });
    }

    replaceElementWrapper(currentEl, nextEl, selector) {
      const $currentEl = currentEl?.querySelectorAll(selector);
      const $nextEl = nextEl?.querySelectorAll(selector);
      if (!$currentEl || !$nextEl) return false;

      $currentEl.forEach((item, index) => {
        if (!$nextEl[index]) return;
        item.innerHTML = $nextEl[index].innerHTML;
      });
      return true;
    }

    updatePrice(variant, element) {
      const currency = Shopify.currency.active;
      const language = Shopify.locale + '-' + Shopify.country;
      if (variant.price) {
        const priceFormat = (variant.price / 100).toLocaleString(language, {
          style: 'currency',
          currency: currency,
        });
        element.querySelector('[data-product-price]').textContent = priceFormat;
      }
      if (variant.compare_at_price) {
        const comparePriceFormat = (variant.compare_at_price / 100).toLocaleString(language, {
          style: 'currency',
          currency: currency,
        });
        element.querySelector('[data-product-compare-price]').textContent = comparePriceFormat;
      }
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        element.querySelector('[data-product-compare-price]').classList.remove('hidden');
      } else {
        element.querySelector('[data-product-compare-price]').classList.add('hidden');
      }
    }

    applyCurrentVariant(firstLoad = false) {
      const selectedValues = this.getSelectedOptionValues();
      const variant = this.findVariantByOptions(selectedValues);
      const productId = this.dataset.productId;

      if (!firstLoad) {
        const previousVariantId = this.dataset.productVariantId || '';
        const nextVariantId = variant ? String(variant.id) : '';
        if (previousVariantId === nextVariantId) {
          return variant;
        }
      }

      if (variant) {
        this.dataset.productVariantId = String(variant.id);
        this.dataset.variantAvailable = variant.available;
        this.updateProductInfo(variant, variant.available);
        if (!firstLoad) {
          this.updateProductDetail(variant, variant.available);
        }
      } else {
        this.dataset.variantAvailable = false;
        this.updateProductInfo(variant, false);
        if (!firstLoad) {
          this.updateProductDetail(variant, false);
        }
      }

      // get current option value text
      this.querySelectorAll('[data-option-value-text]:checked').forEach((element) => {
        const parentValueText = element
          .closest('.lx-variant-selector__option')
          .querySelector('.lx-variant-selector__option-value-text');
        if (parentValueText) {
          parentValueText.textContent = element.dataset.optionValueText;
        }
      });

      this.updateVariantStatuses();

      this.dispatchEvent(
        new CustomEvent('lx-variant-selector:change', {
          bubbles: true,
          detail: { variant, selectedValues, product: productId },
        })
      );

      return variant;
    }

    handleChange(event) {
      const target = event?.target;
      const isOptionInput =
        target instanceof HTMLInputElement &&
        target.type === 'radio' &&
        typeof target.name === 'string' &&
        target.name.startsWith('option-');

      if (isOptionInput) {
        const changedPosIndex = Number(target.name.replace('option-', '')) - 1;
        const selectedValues = this.getSelectedOptionValues();
        const currentVariant = this.findVariantByOptions(selectedValues);

        if (!currentVariant && changedPosIndex >= 0) {
          const fallbackVariant = this.findBestComposableVariant(changedPosIndex, target.value, selectedValues);
          if (fallbackVariant) {
            this.syncRadiosFromVariant(fallbackVariant);
          }
        }
      }

      this.applyCurrentVariant();
    }

    getCurrentVariant() {
      return this.findVariantByOptions(this.getSelectedOptionValues());
    }
  }

  if (!customElements.get('lx-variant-selector-v1')) {
    customElements.define('lx-variant-selector-v1', LXVariantSelectorV1);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-variant-selector"] && !Shopify.designMode) return;
  try {
    class LXVariantSelector extends HTMLElement {
    constructor() {
      super();
      this._onFormChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.variantsScript = this.form.querySelector('script[type="application/json"]');
      this.variants = this.parseVariants();

      this.form.addEventListener('change', this._onFormChange);
      this.syncRadiosFromVariantId(this.dataset.productVariantId);
      this.applyCurrentVariant();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this._onFormChange);
    }

    parseVariants() {
      if (!this.variantsScript?.textContent) return [];
      try {
        const data = JSON.parse(this.variantsScript.textContent);
        return Array.isArray(data) ? data : [];
      } catch {
        return [];
      }
    }

    /** 按 option position 顺序读取当前选中的选项值（与 JSON 里 option1/2/3 对齐） */
    getOptionGroups() {
      const root = this.querySelector('.lx-variant-selector__options');
      if (!root) return [];

      return Array.from(root.querySelectorAll('.lx-variant-selector__option')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    }

    getSelectedOptionValues() {
      return this.getOptionGroups().map((group) => {
        const input = group.querySelector('input[type="radio"]:checked');
        return input ? input.value : null;
      });
    }

    variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues) {
      if (variant[`option${posIndex + 1}`] !== candidateValue) return false;

      for (let j = 0; j < selectedValues.length; j += 1) {
        if (j === posIndex) continue;
        const sel = selectedValues[j];
        if (sel == null || sel === '') continue;
        if (variant[`option${j + 1}`] !== sel) return false;
      }

      return true;
    }

    /**
     * 当前选中值下，该维度取 candidateValue、其余维度沿用 selectedValues 时的组合状态。
     * selectedValues 中未选维度（null）不参与约束。
     * 返回 canPurchase、currentVariantNull（无变体行匹配该组合，例如仅有 Standard/Jungle Camo 而无 Large/Jungle Camo）。
     */
    hasAvailableVariantForCandidate(posIndex, candidateValue, selectedValues) {
      let hasAnyVariant = false;
      let hasAvailableVariant = false;

      for (const variant of this.variants) {
        if (!this.variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues)) continue;
        hasAnyVariant = true;
        if (variant.available === true) hasAvailableVariant = true;
      }

      return {
        currentVariantNull: !hasAnyVariant,
        canPurchase: hasAvailableVariant,
      };
    }

    /**
     * 根据当前各组选中项，更新每组内 radio。
     * - 组合在 JSON 中不存在（currentVariantNull）：始终对非当前选中项设置 disabled，忽略 canDisableInputSelection。
     * - 组合存在但售罄：仅当 data-can-disable-input-selection 为 true 时设置 disabled。
     * 已选中的项不 disabled，避免无法改选。
     */
    updateVariantStatuses() {
      if (!this.form || !this.variants.length) return;

      const selectedValues = this.getSelectedOptionValues();
      const groups = this.getOptionGroups();
      const allowDisableForSoldOut = this.dataset.canDisableInputSelection === 'true';

      groups.forEach((group, posIndex) => {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const { currentVariantNull, canPurchase } = this.hasAvailableVariantForCandidate(
            posIndex,
            input.value,
            selectedValues
          );

          let nativeDisabled = false;
          if (!input.checked) {
            if (currentVariantNull) {
              nativeDisabled = true;
            } else if (allowDisableForSoldOut && !canPurchase) {
              nativeDisabled = true;
            }
          }

          // input.disabled = nativeDisabled;
          input.classList.toggle('unavailable', nativeDisabled);
          input.parentElement.classList.toggle('unavailable', nativeDisabled);

          input.classList.toggle('disabled', currentVariantNull || !canPurchase);
        });
      });
    }

    findVariantByOptions(selectedValues) {
      if (!this.variants.length || selectedValues.some((v) => v == null || v === '')) {
        return null;
      }

      return (
        this.variants.find((variant) =>
          selectedValues.every((val, index) => {
            const key = `option${index + 1}`;
            return variant[key] === val;
          })
        ) || null
      );
    }

    syncRadiosFromVariant(variant) {
      if (!variant || !this.form) return;

      const groups = this.getOptionGroups();
      groups.forEach((group, index) => {
        const targetValue = variant[`option${index + 1}`];
        if (targetValue == null) return;

        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === targetValue;
        });
      });
    }

    findBestComposableVariant(changedPosIndex, changedValue, selectedValues) {
      const candidates = this.variants.filter((variant) => variant[`option${changedPosIndex + 1}`] === changedValue);
      if (!candidates.length) return null;

      const getScore = (variant) => {
        let score = variant.available ? 100 : 0;
        for (let i = 0; i < selectedValues.length; i += 1) {
          if (i === changedPosIndex) continue;
          const selected = selectedValues[i];
          if (selected && variant[`option${i + 1}`] === selected) score += 1;
        }
        return score;
      };

      let best = candidates[0];
      let bestScore = getScore(best);
      for (let i = 1; i < candidates.length; i += 1) {
        const current = candidates[i];
        const score = getScore(current);
        if (score > bestScore) {
          best = current;
          bestScore = score;
        }
      }

      return best;
    }

    syncRadiosFromVariantId(variantId) {
      if (!variantId || !this.variants.length) return;

      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      for (let i = 1; i <= 3; i += 1) {
        const val = variant[`option${i}`];
        if (val == null) continue;

        const inputs = this.form.querySelectorAll(`input[type="radio"][name="option-${i}"]`);
        inputs.forEach((input) => {
          input.checked = input.value === val;
        });
      }
    }

    updateProductInfo(variant, available = true) {
      // match element by [data-product-card] or [data-product-info]
      const productElement = this.closest('[data-product-card]') || this.closest('[data-product-info]');
      if (!productElement) return;
      //   update variant available
      productElement.dataset.variantAvailable = available;
      // update product variant id
      productElement.dataset.productVariantId = available ? String(variant.id) : '';
      // update add variant, match element by [data-add-variant]
      productElement.querySelectorAll('[data-add-variant]').forEach((element) => {
        element.dataset.addVariant = available ? String(variant.id) : '';
      });
      // update product link, match element by [data-product-link]
      productElement.querySelectorAll('[data-product-link]').forEach((element) => {
        element.href = available ? `${this.dataset.productUrl}?variant=${variant.id}` : `${this.dataset.productUrl}`;
      });
      // update product image, match element by [data-product-image]
      if (variant) {
        const imageWidth = Math.max(320, Math.min(800, window.innerWidth * 1.5));
        productElement.querySelectorAll('[data-product-image]').forEach((element) => {
          element.src = `${variant.featured_image.src}&width=${imageWidth}`;
        });
      }
      // update product price, match element by [data-product-price-element]
      if (variant) {
        productElement.querySelectorAll('[data-product-price-element]').forEach((element) => {
          if (variant.price) {
            const priceFormat = (variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            element.querySelector('[data-product-price]').textContent = priceFormat;
          }
          if (variant.compare_at_price) {
            const comparePriceFormat = (variant.compare_at_price / 100).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            });
            element.querySelector('[data-product-compare-price]').textContent = comparePriceFormat;
          }
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            element.querySelector('[data-product-compare-price]').classList.remove('hidden');
          } else {
            element.querySelector('[data-product-compare-price]').classList.add('hidden');
          }
        });
      }
    }

    applyCurrentVariant() {
      const selectedValues = this.getSelectedOptionValues();
      const variant = this.findVariantByOptions(selectedValues);
      const productId = this.dataset.productId;

      if (variant) {
        this.dataset.productVariantId = String(variant.id);
        this.dataset.variantAvailable = variant.available;
        this.updateProductInfo(variant, variant.available);
      } else {
        this.dataset.variantAvailable = false;
        this.updateProductInfo(variant, false);
      }

      // get current option value text
      this.querySelectorAll('[data-option-value-text]:checked').forEach((element) => {
        const parentValueText = element
          .closest('.lx-variant-selector__option')
          .querySelector('.lx-variant-selector__option-value-text');
        if (parentValueText) {
          parentValueText.textContent = element.dataset.optionValueText;
        }
      });

      this.updateVariantStatuses();

      this.dispatchEvent(
        new CustomEvent('lx-variant-selector:change', {
          bubbles: true,
          detail: { variant, selectedValues, product: productId },
        })
      );

      return variant;
    }

    handleChange(event) {
      const target = event?.target;
      const isOptionInput =
        target instanceof HTMLInputElement &&
        target.type === 'radio' &&
        typeof target.name === 'string' &&
        target.name.startsWith('option-');

      if (isOptionInput) {
        const changedPosIndex = Number(target.name.replace('option-', '')) - 1;
        const selectedValues = this.getSelectedOptionValues();
        const currentVariant = this.findVariantByOptions(selectedValues);

        if (!currentVariant && changedPosIndex >= 0) {
          const fallbackVariant = this.findBestComposableVariant(changedPosIndex, target.value, selectedValues);
          if (fallbackVariant) {
            this.syncRadiosFromVariant(fallbackVariant);
          }
        }
      }

      this.applyCurrentVariant();
    }

    getCurrentVariant() {
      return this.findVariantByOptions(this.getSelectedOptionValues());
    }
  }

  if (!customElements.get('lx-variant-selector')) {
    customElements.define('lx-variant-selector', LXVariantSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
